module.exports = __webpack_public_path__ + "img/desktop-monitor-approve.dd72d39d.svg";